import { render, staticRenderFns } from "./status5.vue?vue&type=template&id=74518afe&scoped=true&"
import script from "./status5.vue?vue&type=script&lang=js&"
export * from "./status5.vue?vue&type=script&lang=js&"
import style0 from "./status5.vue?vue&type=style&index=0&id=74518afe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74518afe",
  null
  
)

export default component.exports